import { useRef, useState } from 'react';
import { useEffectAsync } from 'zf-web-components';
import { Link } from 'react-router';
import { MenuService } from '@services';
import { useApp } from '@components';
import type { MenuIconMap, MenuItems, MenuItemGroupType, MenuItemType } from '@services';
import type { MenuData } from './types';

export function useLoadMenu(iconMap: MenuIconMap): MenuData {
  const { current: service } = useRef(new MenuService());
  const [loading, setLoading] = useState(false);
  const [appMenus, setAppMenu] = useState<MenuItems>([]);
  const [systemMenus, setSystemMenu] = useState<MenuItems>([]);
  const { app } = useApp();

  useEffectAsync(async (): Promise<void> => {
    setLoading(true);
    const appMenus = await service.fetchMenu(app, iconMap);
    const systemMenus = await service.fetchMenu('system', iconMap);
    setAppMenu(convertMenuItems(appMenus));
    // 先调用app菜单，再调用系统菜单, 保证菜单返回数据只包含当前服务以及系统菜单
    setSystemMenu(convertMenuItems(systemMenus));
    setLoading(false);
  }, [app]);

  const convertMenuItems = (menus: MenuItems): MenuItems => menus.map(menu => {
    if ((menu as MenuItemGroupType).children?.length > 0) {
      return {
        ...menu,
        children: (menu as MenuItemGroupType).children.map(child => ({
          ...child,
          label: (
            <Link
              to={(child as MenuItemType).url}
              style={{
                color: 'inherit',
                textDecoration: 'none'
              }}>
              {(child as MenuItemType).label}
            </Link>
          )
        }))
      };
    }
    return {
      ...menu,
      label: (
        <Link
          to={(menu as MenuItemType).url}
          style={{
            color: 'inherit',
            textDecoration: 'none'
          }}>
          {(menu as MenuItemType).label}
        </Link>
      )
    };
  });

  return { loading, appMenus, systemMenus };
}
